import React, { useState, useEffect } from "react";
import { useHistory } from "react-router-dom";
import Modal from "../ui_utilities/Modal";
import Button from "@material-ui/core/Button";
import { saveEula } from "../../common/services/legal.service";
import {
  appConstants,
  legal_agreement_eula as eula,
} from "../../common/constants/constants";

export function EULA(props) {
  const legal = props.legal;
  const userInfo = props.userInfo;
  const handleLegalUpdate = props.handleLegalUpdate;
  const history = useHistory();
  const [eulaValid, setEulaValid] = useState(false);

  const validateEula = (legal) => {
    if (legal) {
      if (legal.eula?.version != null && legal.eula?.version >= eula.version) {
        setEulaValid(true);
      }
    }
  };

  useEffect(() => {
    validateEula(legal);
  }, [legal]);

  const handleAgree = () => {
    const eulaUpdate = { eula: { version: eula.version } };
    saveEula(eulaUpdate)
      .then((response) => {
        if (response.data.timestamp) {
          const updatedLegal = {
            ...legal,
            eula: response.data,
          };
          handleLegalUpdate(updatedLegal);
        }
      })
      .catch((err) => {
        console.log("Error :: " + err);
      });
  };

  const handleDisagree = () => {
    localStorage.clear();
    window.location.href = "/login";
  };

  const handleDownload = () => {
    window.open(eula.downloadURL, "_blank");
  };

  const title = <>{eula.title}</>;

  const content = (
    <div>
      <div>
        <Button
          style={{ "margin-bottom": "20px" }}
          onClick={handleDownload}
          className="button size-mini"
          variant="outlined"
        >
          {eula.downloadText}
        </Button>
      </div>
      <div
        style={{ textAlign: "justify", "text-justify": "inter-word" }}
        dangerouslySetInnerHTML={{ __html: eula.legalText }}
      ></div>
    </div>
  );

  const actions = (
    <div>
      <Button
        onClick={handleDisagree}
        className="button size-mini"
        variant="outlined"
      >
        {eula.disagreeText}
      </Button>
      <Button
        onClick={handleAgree}
        className="button size-mini"
        variant="contained"
      >
        {eula.agreeText}
      </Button>
    </div>
  );

  return (
    <>
      {userInfo.userType === appConstants.External && legal && !eulaValid && (
        <Modal
          title={title}
          content={content}
          actions={actions}
          maxWidth="md"
          open={true}
        />
      )}
    </>
  );
}
